function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function str(value: unknown): string | null {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

/** Short human title for an array row card. */
export function rowTitle(item: unknown, index: number, pathHint?: string): string {
  if (!isRecord(item)) {
    if (typeof item === "string") {
      return item.length > 48 ? `${item.slice(0, 48)}…` : item || `项 ${index + 1}`;
    }
    return `项 ${index + 1}`;
  }

  const sender = str(item.sender);
  const receiver = str(item.receiver);
  if (sender && receiver) {
    const when = str(item.sent_at) ?? str(item.received_at);
    return when ? `${sender} → ${receiver} · ${when}` : `${sender} → ${receiver}`;
  }

  const question = str(item.question);
  if (question) {
    return question.length > 56 ? `${question.slice(0, 56)}…` : question;
  }

  const name = str(item.name);
  if (name) {
    return name;
  }

  const title = str(item.title) ?? str(item.subject) ?? str(item.headline);
  if (title) {
    return title.length > 56 ? `${title.slice(0, 56)}…` : title;
  }

  const caption = str(item.caption) ?? str(item.body);
  if (caption) {
    return caption.length > 56 ? `${caption.slice(0, 56)}…` : caption;
  }

  const kind = str(item.kind);
  if (kind) return `${kind} · 步骤 ${index + 1}`;

  const from = str(item.from);
  const to = str(item.to);
  if (from && to) {
    return `${from} → ${to}`;
  }

  const city = str(item.city);
  const day = str(item.day);
  if (city && day) return `${city} · ${day}`;

  const location = str(item.location) ?? str(item.poi);
  if (location) return location;

  if (pathHint?.includes("guideSteps")) {
    return `引导 ${index + 1}`;
  }

  return `项 ${index + 1}`;
}
